import { EFinancingProgram } from '@if/core/types'
import programResources from '@src/data/programResources.json'
import { MerchantResource } from '@src/types/MerchantResource'
import { useMemo } from 'react'

const documentsByProgram: Record<string, Record<string, { file: string; label: string }[] | undefined> | undefined> =
  programResources

const getResources = (supportedFinancingPrograms: EFinancingProgram[], language: string): MerchantResource[] =>
  supportedFinancingPrograms.flatMap((program) =>
    (documentsByProgram[program]?.[language] ?? []).map((document) => ({
      name: document.label,
      href: `/assets/resources/${program}/${language}/${document.file}`,
      download: true,
      program,
    })),
  )

const useResources = (supportedFinancingPrograms: EFinancingProgram[], language: string): MerchantResource[] =>
  useMemo(() => getResources(supportedFinancingPrograms, language), [supportedFinancingPrograms, language])

export default useResources
